/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.modals.assign.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.auth',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.directive.hoverTooltip',
    'acme.view.application.dataGrid.controllers'
])

    .controller('ResourcesModalsAssignController', ['$scope', '$state', '$rootScope', '$uibModalInstance', '$timeout', 'ApiService', 'AuthService', 'GridStateFactory', 'GridDefinitionFactory', 'NoticeFactory', 'request', 'emailSetting', function ($scope, $state, $rootScope, $uibModalInstance, $timeout, ApiService, AuthService, GridStateFactory, GridDefinitionFactory, NoticeFactory, request, emailSetting) {

        $scope.resourcesModalsAssign = {
            search: '',
            match: true,
            available: true,
            isLoaded: false,
            isUpdating: false,
            model: [],
            resourceRequest: '',

            notificationEmail: true,
            notificationType: 'always',
            notificationList: [],

            user: false,

            selected: false,
            gridName: $state.current.name + '.modal.grid0',

            optionsOverride: {
                useAccessibleGrid: true,
                data: 'resourcesModalsAssign.model',
                enableGridMenu: false,
                paginationPageSize: 10,
                paginationPageSizes: [10],
                appScopeProvider: {
                    onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
                        $scope.resourcesModalsAssign.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
                    },
                    onDataGridSortChange: function (grid, columns) {
                        $scope.resourcesModalsAssign.onDataGridSortChange(grid, columns);
                    },
                    onDataGridSelectionChange: function (row, e) {
                        $scope.resourcesModalsAssign.onRowSelectionChanged(row, e);
                    },
                    getIcon: function () {
                        return "<span class=\"fa fa-info-circle\" role=\"presentation\"></span>";
                    },
                    hasSeveralTypes: function (row) {
                        return row.entity.resourceTemplateNames.length > 1;
                    },
                    getTooltipContent: function (row) {
                        var template = '';
                        var types = row.entity.resourceTemplateNames;
                        template = '<ul>';
                        for (var x = 0; x < types.length; x++) {
                            template = template + '<li>' + types[x] + '</li>';
                        }
                        template = template + '</ul>';
                        return template;
                    },
                    getTypesTemplate: function (row) {
                        var template = '';
                        var types = row.entity.resourceTemplateNames;
                        if (types.length === 1) {
                            template = types[0];
                        } else {
                            template = "<em> " + types.length + " Types </em>";
                        }
                        return template;
                    }
                },
                columnDefs: [
                    {
                        field: 'resourceName',
                        displayName: 'Name',
                        colId: 'resourceName',
                        sort: {
                            direction: 'asc'
                        },
                        cellTemplate: "<div data-hover-tooltip data-element-to-hover=\"COL_FIELD\" data-tooltip-contents=\"COL_FIELD\" data-position=\"'bottom'\" data-long-content-only=\"'true'\"></div>"
                    },
                    {
                        field: 'resourceTemplateNames',
                        displayName: 'Type',
                        colId: 'resourceTemplateNames',
                        cellTemplate: "<div data-hover-tooltip data-element-to-hover=\"grid.appScope.getTypesTemplate(row)\" data-tooltip-contents=\"grid.appScope.getTypesTemplate(row)\" data-position=\"'bottom'\" data-long-content-only=\"'true'\"></div><div data-ng-show='grid.appScope.hasSeveralTypes(row)' data-hover-tooltip class=\"info-icon\" data-element-to-hover=\"grid.appScope.getIcon()\" data-tooltip-contents=\"grid.appScope.getTooltipContent(row)\" data-position=\"'top'\"></div></div>"
                    },
                    {
                        field: 'match',
                        displayName: 'Match',
                        cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="fa fa-check text-success" data-ng-show="row.entity.match"><span class="sr-only">Yes</span></span><span class="fa fa-ban text-danger" data-ng-hide="row.entity.match"><span class="sr-only">No</span></span></div>',
                        width: 100
                    },
                    {
                        field: 'available',
                        displayName: 'Available',
                        cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="fa fa-check text-success" data-ng-show="row.entity.available"><span class="sr-only">Yes</span></span><span class="fa fa-ban text-danger" data-ng-hide="row.entity.available"><span class="sr-only">No</span></span></div>',
                        width: 100
                    },
                    {
                        field: 'conflicts',
                        displayName: 'No Conflicts',
                        cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="fa fa-check text-success" data-ng-hide="row.entity.conflicts"><span class="sr-only">Yes</span></span><span class="fa fa-ban text-danger" data-ng-show="row.entity.conflicts"><span class="sr-only">No</span></span></div>',
                        width: 130
                    }
                ]
            },

            notice: new NoticeFactory(),
            gridState: new GridStateFactory(),
            gridDefinition: new GridDefinitionFactory(),
            viewId: '',

            init: function () {

                $scope.$on('$destroy', $scope.$watch('resourcesModalsAssign.match', this.onMatchUpdate));
                $scope.$on('$destroy', $scope.$watch('resourcesModalsAssign.available', this.onAvailableUpdate));

                this.viewId = $state.current.name;

                this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

                this.getCurrentUser();

                this.notificationType = emailSetting;

                this.setNotificationList();

                $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

            },

            initData: function () {
                var self = $scope.resourcesModalsAssign, props = self.gridDefinition.getGridState();
                self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
                self.getResourceRequests();
            },

            setNotificationList: function () {
                if (request.resourceCategory === 'Personnel' && request.resourceName) {
                    this.notificationList = [];
                    this.notificationList.push(request.resourceName);
                }
            },

            isCategory: function (type) {
                return request.resourceCategory && request.resourceCategory === type;
            },

            canAssignToSelf: function () {
                var r = false;

                if (this.isCategory('Personnel') && this.user) {
                    this.search = this.user.firstName + ' ' + this.user.lastName;
                    this.gridState.setPropertyValue('search', this.search);
                    r = true;
                }
                return r;
            },

            canUnassign: function () {
                var r = false;

                if (this.isCategory('Personnel')) {
                    // Is personnel and only has self assign
                    if (AuthService.hasPermission('RESOURCES_REQUESTS_ASSIGN')) {
                        r = true;
                    } else if (!AuthService.hasPermission('RESOURCES_REQUESTS_ASSIGN') &&
                        AuthService.hasPermission('RESOURCES_REQUESTS_SELF_ASSIGN') &&
                        this.user.id === request.ownerId) {
                        r = true;
                    }
                } else if (AuthService.hasPermission('RESOURCES_REQUESTS_ASSIGN')) {
                    r = true;
                }

                return r;

            },

            selfAssignCheck: function () {
                var props = $.extend({
                    id: request.id,
                    match: 'false',
                    available: 'false'
                }, this.gridState.getGridState());

                this.isUpdating = true;
                if (!props.id && request.eventResourceRequestId) {
                    props.id = request.eventResourceRequestId;
                }

                if (request.resourceCategory === 'Personnel' &&
                    AuthService.hasPermission('RESOURCES_REQUESTS_ASSIGN') ||
                    AuthService.hasPermission('RESOURCES_REQUESTS_SELF_ASSIGN')) {
                    props.resourceOwnerId = this.user.id;
                }

                return ApiService.resource.assignment.request(props);
            },

            query: function () {
                var self = $scope.resourcesModalsAssign;
                self.gridState.setPropertyValue('search', this.search);
                $scope.$broadcast('DataGrid::Search', {name: self.gridName});
            },

            getResourceRequests: function () {
                var props;

                this.isLoaded = false;
                this.gridDefinition.isLoaded = true;

                if (request.hasOwnProperty(('id'))) {

                    props = $.extend({
                        id: request.id,
                        match: this.match ? this.match : 'false',
                        available: this.available ? this.available : 'false',
                        resourceOwnerId: request.resourceOwnerId || false
                    }, this.gridState.getGridState());

                    ApiService.resource.assignment.request(props).then(this.success.getResourceRequests, this.error.getResourceRequests);

                } else if (request.hasOwnProperty('eventResourceRequestId')) {

                    props = $.extend({
                        id: request.eventResourceRequestId,
                        match: this.match ? this.match : 'false',
                        available: this.available ? this.available : 'false',
                        resourceOwnerId: request.resourceOwnerId || false
                    }, this.gridState.getGridState());

                    ApiService.resource.assignment.request(props).then(this.success.getResourceRequests, this.error.getResourceRequests);

                } else {
                    this.isLoaded = true;
                    this.gridDefinition.isLoaded = true;
                }
            },

            getCurrentUser: function () {
                this.user = AuthService.getCookie('user');
            },

            getResourceName: function () {
                var r = false;
                if (request && request.resourceName) {
                    r = request.resourceName;
                }
                return r;
            },

            selectResource: function () {
                var i, ii,
                    selected = [];

                if (request.resourceId) {
                    for (i = 0, ii = this.model.length; i < ii; i++) {
                        if (this.model[i].resource && this.model[i].resource.id === request.resourceId) {
                            selected.push(this.model[i]);
                            break;
                        }
                    }

                    if (selected instanceof Array) {
                        $scope.$broadcast('DataGrid::SetSelection', selected);
                    }
                }
            },

            clearSelectedResource: function () {
                $scope.$broadcast('DataGrid::ClearSelection');
            },

            assign: function (close) {
                var self = $scope.resourcesModalsAssign,
                    props = {
                        resourceRequestId: request.id
                    };

                if (!props.resourceRequestId && request.eventResourceRequestId) {
                    props.resourceRequestId = request.eventResourceRequestId;
                }

                self.isUpdating = true;
                self.notice.hideErrorMessages();
                self.checkNotification();

                if (self.selected) {
                    props.resourceId = self.selected.resourceId;
                    props.notificationEmail = self.notificationEmail;
                    props.sendEmail = self.notificationEmail;
                    ApiService.resource.assignment.assign(props).then(function (response) {
                        self.success.assign(response);
                        self.close(response.data.payload);
                    }, self.error.assign);
                } else if (close) {
                    self.close(request);
                }

            },

            unassign: function () {
                var self = $scope.resourcesModalsAssign,
                    props = {
                        resourceRequestId: request.id,
                        sendEmail: this.notificationEmail
                    };

                self.isUpdating = true;
                if (!props.resourceRequestId && request.eventResourceRequestId) {
                    props.resourceRequestId = request.eventResourceRequestId;
                }

                self.notice.hideErrorMessages();

                if (self.selected) {
                    props.resourceId = self.selected.id;
                }

                ApiService.resource.assignment.unassign(props).then(self.success.unassign, self.error.unassign);
            },

            findResource: function (id) {
                var i, ii, r = false;

                if (id) {
                    for (i = 0, ii = this.model.length; i < ii; i++) {
                        if (this.model[i].resource && this.model[i].resource.id === id) {
                            r = {
                                resource: this.model[i].resource,
                                index: i
                            };
                            break;
                        }
                    }
                }

                return r;
            },

            findResourcesByOwner: function (id) {
                var i, ii,
                    r = [];

                if (id) {
                    for (i = 0, ii = this.model.length; i < ii; i++) {
                        if (this.model[i].ownerId && this.model[i].ownerId === "" + id) {
                            r.push({
                                resource: this.model[i],
                                index: i
                            });
                        }
                    }
                }

                return r;
            },

            findMatch: function(resources) {
                var i, ii,
                    r = false;

                if (resources instanceof Array && resources.length) {
                    r = resources[0].resource;
                }

                return r;
            },

            findClosestMatch: function (resources) {
                var i, ii,
                    r = false;

                if (resources instanceof Array) {
                    for (i = 0, ii = resources.length; i < ii; i++) {
                        if (resources[i].resource.resourceTemplateId === request.resourceTemplateId) {
                            r = resources[i].resource;
                            break;
                        }
                    }
                    // Couldn't find a match snag the first hit regardless
                    if (!r && ii > 0) {
                        r = resources[0].resource;
                    }
                }

                return r;
            },

            findClosestResourceFieldMatch: function (resource) {

                var i, ii,
                    r = false;

                if (resource.fields instanceof Array && resource.fields.length) {
                    for (i = 0, ii = resource.fields.length; i < ii; i++) {
                        if (resource.fields[i].resourceTemplateId === request.resourceTemplateId) {
                            r = {
                                field: resource.fields[i],
                                index: i
                            };
                            break;
                        }
                    }

                    if (!r) {
                        r = {
                            field: resource.fields[0],
                            index: 0
                        };
                    }

                }

                return r;

            },

            assignToSelf: function () {
                var self = $scope.resourcesModalsAssign;

                self.notice.hideErrorMessages();

                if (self.canAssignToSelf()) {
                    self.selfAssignCheck().then(self.success.assignToSelf, self.error.assignToSelf);
                }

            },

            checkNotification: function () {
                if (this.notificationType === 'always') {
                    this.notificationEmail = true;
                } else if (this.notificationType === 'never') {
                    this.notificationEmail = false;
                }

                this.model.sendEmail = this.notificationEmail;
            },

            done: function () {
                this.close(request);
            },

            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            },

            close: function (request) {
                $uibModalInstance.close(request);
                this.isUpdating = false;
            },

            success: {

                init: function (response) {
                },

                getResourceRequests: function (response) {
                    var self = $scope.resourcesModalsAssign;

                    self.model = response.data.payload.list;

                    self.resourceRequest = request.resourceTemplateName;

                    //next tick
                    $timeout(function () {
                        self.selectResource();
                        $scope.$broadcast('DataGrid::ResizeGrid', {
                            name: self.gridDefinition.options.gridName,
                            datasetLength: self.model.length,
                            totalItems: response.data.payload.pagination.count
                        });
                        self.gridDefinition.isLoaded = true;
                    }, 10);

                    self.isLoaded = true;
                },

                assign: function (response) {
                    var self = $scope.resourcesModalsAssign;

                    request = response.data.payload;

                    if (!request.resourceId) {
                        request.resourceId = self.selected.resourceId;
                    }
                    if (!request.resourceName) {
                        request.resourceName = self.selected.resourceName;
                    }
                },

                unassign: function (response) {
                    var self = $scope.resourcesModalsAssign;
                    request.resourceName = '';
                    request.resourceId = '';
                    self.clearSelectedResource();
                    self.isUpdating = false;
                    $uibModalInstance.dismiss();
                },

                assignToSelf: function (response) {

                    var found,
                        self = $scope.resourcesModalsAssign;

                    self.model = response.data.payload.list;

                    if (self.model.length) {
                        $timeout(function () {

                            found = self.findMatch(self.findResourcesByOwner(self.user.id));

                            if (found) {
                                self.selected = found;
                                $scope.$broadcast('DataGrid::SetSelection', [self.selected]);
                                self.assign(true);
                            } else {
                                self.notice.showErrorMessages([{
                                    message: 'Unable to assign, you are not a resource in the system'
                                }]);
                                $rootScope.$broadcast('ResourcesModalsAssignController::error', self.notice.errors[0]);
                            }
                        });
                    } else {
                        self.notice.showErrorMessages([{
                            message: 'Unable to assign, you are not a resource in the system'
                        }]);
                        $rootScope.$broadcast('ResourcesModalsAssignController::error', self.notice.errors[0]);
                    }

                    self.isLoaded = true;
                    self.isUpdating = false;
                    self.gridDefinition.isLoaded = true;

                }

            },

            error: {

                init: function (response) {
                },
                generic: function (response) {
                    var self = $scope.resourcesModalsAssign;

                    self.notice.showErrorMessages([{
                        message: response.data.error
                    }]);

                    self.isLoaded = true;
                    self.isUpdating = false;
                    self.gridDefinition.isLoaded = true;
                },

                getResourceRequests: function (response) {
                    $scope.resourcesModalsAssign.error.generic(response);
                },

                assign: function (response) {
                    $scope.resourcesModalsAssign.error.generic(response);
                },

                unassign: function (response) {
                    $scope.resourcesModalsAssign.error.generic(response);
                },

                assignToSelf: function (response) {
                    $scope.resourcesModalsAssign.error.generic(response);
                    $rootScope.$broadcast('ResourcesModalsAssignController::error', {message: response.data.error});
                }

            },

            onMatchUpdate: function (n, o) {
                var self = $scope.resourcesModalsAssign;
                if (n !== o) {
                    $scope.$broadcast('DataGrid::Search', {name: self.gridName});
                }
            },

            onAvailableUpdate: function (n, o) {
                var self = $scope.resourcesModalsAssign;
                if (n !== o) {
                    $scope.$broadcast('DataGrid::Search', {name: self.gridName});
                }
            },

            onRowSelectionChanged: function (row, e) {
                var self = $scope.resourcesModalsAssign;
                self.setNotificationList();
                if (row && row.isSelected &&
                    row.entity && row.entity.resourceCategory &&
                    row.entity.resourceId) {
                    self.selected = row.entity;
                    if (row.entity.resourceCategory.toUpperCase() === 'PERSONNEL') {
                        self.notificationList = [];
                        self.notificationList.push(self.selected.resourceName);
                    }
                } else {
                    if (row && !row.isSelected) {
                        self.selected = false;
                    }
                }
            },

            onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
                var self = $scope.resourcesModalsAssign;

                self.gridState.updateGridState(newPage, pageSize);
                if (sortField) {
                    self.gridState.updateGridState(null, null, sortField, null);
                }
                if (sortDirection) {
                    self.gridState.updateGridState(null, null, null, sortDirection);
                }
                self.getResourceRequests();
            },

            onDataGridSortChange: function (grid, columns) {
                var self = $scope.resourcesModalsAssign,
                    data = columns[0];

                if (data) {
                    self.gridState.updateGridState(null, null, data.field, data.sort.direction);
                    self.getResourceRequests();
                }
            }

        };

        $scope.resourcesModalsAssign.init();

    }]);